import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=45a8ed48&"
import script from "./NewUser.vue?vue&type=script&lang=ts&"
export * from "./NewUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports